module.exports = __webpack_public_path__ + "static/img/fm5.370d4ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm5.jpg
// module id = B6Rv
// module chunks = 1